import React, { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { SearchContext } from "../../../context/SearchContext";
import styles from "./Navbar.module.css";

const Navbar = () => {
  const navigate = useNavigate();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const userRole = localStorage.getItem("adminRole");
  const { searchTerm, setSearchTerm } = useContext(SearchContext);

  const handleDropdownToggle = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const handleLogout = () => {
    const adminBase = (process.env.REACT_APP_ADMIN_API_URL || "")
      .replace(/\/+$/, "")
      .replace(/\/admin-dashboard$/, "");
    const logoutPath =
      userRole === "staff" || userRole === "admin" || userRole === "superadmin" || userRole === "stringer"
        ? (adminBase ? `${adminBase}/login` : "/login")
        : "https://www.tennisshop.ae/";
    console.log("Logout redirect URL:", logoutPath);

    window.location.href = logoutPath;
  };

  const handleProfileNavigation = () => {
    if (
      userRole === "staff" ||
      userRole === "admin" ||
      userRole === "superadmin" ||
      userRole === "stringer"
    ) {
      navigate(`/dashboard/profile`);
    } else {
      navigate("/customer/dashboard/profile");
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className={styles.navbar}>
      <input
        type="text"
        placeholder="Search"
        className={styles.searchBar}
        value={searchTerm}
        onChange={handleSearchChange}
      />

      <div className={styles.userSection}>
        {(userRole === "superadmin" || userRole === "admin") && (
          <Link to="/pending-requests">
            <button className={styles.pendingInfoButton}>
              Invite Staff 🔔
            </button>
          </Link>
        )}
        <div className={styles.userIcon} onClick={handleDropdownToggle}>
          TS
          {dropdownVisible && (
            <div className={styles.dropdownMenu}>
              <div onClick={handleProfileNavigation}>Profile</div>
              <div onClick={handleLogout}>Logout</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
